export default {
  computed: {
    subtotal () {
      let subtotal = 0;
      this.getGroupedByPartnerProducts.forEach(group => {
        subtotal += group.subtotal
      })
      return subtotal
    }
  },
  methods: {
    productPrice (product) {
      return product.priceInclTax * product.qty;
    }
  }
}
